import Main from "./bluraycd/main.es6";

class Bluraycd {
    constructor() {
        this.main = new Main();
    }
}

const bluraycd = new Bluraycd();
